import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createApiClient } from '@room/frontend-sdk';
import { registerDefaultTiles, setAuthAPI } from '@room/shared-ui';
import { App } from './App';
import './index.css';

// Register default home tiles (Weather, Chat, Store, etc.)
registerDefaultTiles();

const api = createApiClient({
  baseURL: '/api',
  onUnauthorized: () => {
    window.location.href = '/login';
  },
});

setAuthAPI({
  getSession: () => api.get('/auth/session'),
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
